import React, { useEffect, useState } from 'react'
import Layout from './Menu'
import Navbar from './Navbar'
import { Button, Card, CardBody, CardHeader, Col, Container, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap'
import Select from "react-select";
import { RootState } from 'index'
import { useDispatch, useSelector } from 'react-redux'
import { customStyle } from "shared/CommonCSS";
import DateRangePopup from 'ReportGeneration/DateRangePopup';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import { commonValidationMessages } from 'Components/ValidationErrorMessages';
import apiGlobal from 'global/api.global';
import { dateTimeFormat } from 'GenericForms/Helper';
import FormValuesDebug from 'utils/debugTools/FormValuesDebug';
import { getVesselsAction, setOnboardedVessels, setVesselID } from "Store/Generic/ReportingSlice";
import { Filtervalues } from 'shared/CommonInterface';
import classnames from "classnames";
import PageNavButton from 'Dashboard/PendingFiles/PageNavButton';
import TableLoading from 'Components/TableLoading';
import { GetPageWithID } from 'Dashboard/PendingFiles/pendingpage.hook';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import { OnboardingStatus } from 'shared/constants';
import { userVessels } from 'utils/auth/authUtils';

interface sensorStatusFiltersType {
    isPopupOpen?: boolean;
    setFilterValues?: (filterValues: Filtervalues) => void;
    setisPopupOpen?: (isPopupOpen: boolean) => void;
}
export const SensorStatus = ({ isPopupOpen = false, setFilterValues, setisPopupOpen }: sensorStatusFiltersType) => {
    const dispatch = useDispatch();
    const { Vessels, onboardedVessels, VesselID } = useSelector(
        (state: RootState) => state.Reporting
    );
    let applicableVessels = userVessels();
    const [dateRangePopup, setDateRangePopup] = useState(false);
    const [minDate, setMinDate] = useState<any>("");
    const [maxDate, setMaxDate] = useState<any>("");
    const [activeAdjustmentsTab, setActiveAdjustmentsTab] = useState("1");

    // sensor status URL's
    const [energyMeterUrl, setEnergyMeterUrl] = useState("");
    const [revolutionCounterUrl, setRevolutionCounterUrl] = useState("");
    const [kwhMeterUrl, setKwhMeterUrl] = useState("");
    const [refreshField, setRefreshField] = useState(0);

    // constants for pagination
    const { data: energyMeterData, isLoading: loadingEnergy } = useQuery(
        ['energyMeter', energyMeterUrl],
        async () => await GetPageWithID(VesselID, energyMeterUrl),
        { enabled: !!energyMeterUrl }
    );

    const { data: revolutionCounterData, isLoading: loadingRevolution } = useQuery(
        ['revolutionCounter', revolutionCounterUrl],
        async () => await GetPageWithID(VesselID, revolutionCounterUrl),
        { enabled: !!revolutionCounterUrl }
    );

    const { data: kwhMeterData, isLoading: loadingKwh } = useQuery(
        ['kwhMeter', kwhMeterUrl],
        async () => await GetPageWithID(VesselID, kwhMeterUrl),
        { enabled: !!kwhMeterUrl }
    );

    const renderSensorTable = (data: any, isLoading: boolean, setUrl: any, pageUrl: string, sensor_status: any) => {
        if (isLoading) return <TableLoading Rows={2} />;
        if (!data?.results?.length)
            return <div className="text-center py-3">No records found</div>;

        return (
            <div className="table-responsive table-height-10">
                <table className="table mb-0">
                    <thead className="table-light">
                        <tr>
                            <th className="p-2 align-middle text-center">#</th>
                            <th className="p-2 align-middle">Reporting Event</th>
                            <th className="p-2 align-middle">Reporting Date</th>
                            <th className="p-2 align-middle">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.results.map((record: any, index: number) => (
                            <tr key={record.id || index}>
                                <td className="p-2 align-middle text-center">{index + 1}</td>
                                <td className="p-2 align-middle">{record.reporting_event_name}</td>
                                <td className="p-2 align-middle">
                                    {dateTimeFormat(record.reporting_local_time, false, false, true)}
                                </td>
                                <td className="p-2 align-middle">
                                    { getSensorStatus(sensor_status, record[`${sensor_status}`]) === false ? (
                                        <span className="text-danger fw-bold">Not Functional</span>
                                    ) : (
                                        <span className="text-success fw-bold">Functional</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={4}>
                                <PageNavButton
                                    setPageUrl={setUrl}
                                    pageobj={data}
                                    pageUrl={pageUrl}
                                />
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        );
    };

const getSensorStatus = (sensor_name: string, value: boolean) => {
    if (sensor_name === "is_energy_meter_functional") {
        return value === true;
    } 
    else if (sensor_name === "is_revolution_counter_not_functional") {
        return value === false;
    } 
    else if (sensor_name === "is_kwh_meter_not_functional") {
        return value === false;
    }

    return null;
};

    /** Use Effect start */
    /** Populate Vessels array */
    useEffect(() => {
        dispatch(getVesselsAction("vessel_master" as string));
    }, [dispatch]);
    /** Change tabs */
    const toggle = (tab: any) => {
        if (activeAdjustmentsTab !== tab) {
            setActiveAdjustmentsTab(tab);
        }
    };

    useEffect(() => {
        apiGlobal.get(queryKeyes.vessel.GetMinMaxReportDate.url(VesselID)).then(response => {
            setMinDate(response.data?.start_date);
            setMaxDate(response.data?.end_date);
        }).catch(err => {
            console.error(err);
        })
    }, [VesselID])

    useEffect(() => {
        if (Array.isArray(Vessels)) {
            const onboardedVessels = Vessels.filter(
                (vessel) => vessel.onboarding_status === OnboardingStatus.ONBOARDED
            );
            dispatch(setOnboardedVessels(onboardedVessels));
        }
    }, [Vessels, dispatch]);
    /** Use Effect End */

    const validationSchema = Yup.object().shape({
        startDate: Yup.string().required(commonValidationMessages.required).test(
            "start-date-validation",
            "Start date should be less than end date",
            function (startDate: any) {
                const { endDate } = this.parent;
                const startDT = new Date(startDate);
                const endDT = new Date(endDate);
                const minDT = new Date(minDate);
                const maxDT = new Date(maxDate);
                if (startDT && endDT) {
                    if (startDT < minDT && startDate !== null) {
                        return new Yup.ValidationError(`Start date should be same or after ${minDate}`, undefined, `startDate`);

                    }
                    if (startDT >= maxDT) {
                        return new Yup.ValidationError(`Start date should be before ${maxDate}`, undefined, `startDate`);
                    }
                    if (endDT > maxDT) {
                        return new Yup.ValidationError(`End date should be less than ${maxDate}`, undefined, `endDate`);
                    }
                    if (startDT > endDT && endDate !== null) {
                        return new Yup.ValidationError("End date should be after start date", undefined, `endDate`);
                    }
                }
                return true;
            }
        ),
        endDate: Yup.string().required(commonValidationMessages.required),
        startReport: Yup.number()
            .required(commonValidationMessages.required),
        endReport: Yup.number()
            .required(commonValidationMessages.required),
    });


    /** Formik Setup */
    const sensorStatusUseFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            vessel_id: null as number,
            startDate: null as string,
            endDate: null as string,
            startReport: null as number,
            endReport: null as number,
        },
        validationSchema: validationSchema,
        onSubmit: (values: any, actions: any) => {
            actions.setSubmitting(true);
            const { vessel_id, startReport, endReport } = values;
            if (!vessel_id || !startReport || !endReport) {
                console.error("Missing required fields");
                actions.setSubmitting(false);
                return;
            }
            setEnergyMeterUrl(
                queryKeyes.vessel.EnergyParamterSensorStatus.url(vessel_id, startReport, endReport)
            );
            setRevolutionCounterUrl(
                queryKeyes.vessel.VoyageParameterSensorStatus.url(vessel_id, startReport, endReport)
            );
            setKwhMeterUrl(
                queryKeyes.vessel.SpOpEnergySensorStatus.url(vessel_id, startReport, endReport)
            );

            actions.setSubmitting(false);
            setDateRangePopup(false);
        },
    });

    /** Remove data if dependant ID's are null */
    useEffect(() => {
        if (!sensorStatusUseFormik.values.vessel_id || !sensorStatusUseFormik.values.startReport || !sensorStatusUseFormik.values.endReport) {
            setEnergyMeterUrl(null);
            setRevolutionCounterUrl(null);
            setKwhMeterUrl(null);
        }
    }, [
        sensorStatusUseFormik.values.vessel_id,
        sensorStatusUseFormik.values.startReport,
        sensorStatusUseFormik.values.endReport,
    ]);
    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>
            <div className="page-content">
                <Container fluid>
                    <form
                        onSubmit={sensorStatusUseFormik.handleSubmit}
                        noValidate
                        autoComplete="off"
                    >
                        <Card className="p-2">
                            <CardHeader className='p-0'>
                                <h4>Sensor Status</h4>
                            </CardHeader>
                            <CardBody className='p-1'>
                                <Label className="mb-0 me-2">Select vessel</Label>
                                <Row className='align-items-center g-2 flex-nowrap'>
                                    <Col xs="auto">
                                        <Select
                                            className='w-15'
                                            options={
                                                onboardedVessels.filter((item: any) => item.display === true &&
                                                    applicableVessels?.includes(item?.id)) as any[]
                                            }
                                            getOptionLabel={(option: any) => option?.vessel_name_type_name}
                                            getOptionValue={(option: any) => option.id}
                                            menuPortalTarget={document.body}
                                            styles={customStyle}
                                            onChange={async (e: any) => {
                                                sensorStatusUseFormik.setFieldValue("vessel_id", e?.id);
                                                sensorStatusUseFormik.setFieldValue("startDate", null);
                                                sensorStatusUseFormik.setFieldValue("endDate", null);
                                                dispatch(setVesselID(e ? e?.id : null));
                                                setRefreshField(refreshField + 1);
                                            }}
                                            isOptionDisabled={(option: any) => option.is_under_maintenance}
                                        />
                                    </Col>
                                    <Col xs="auto">
                                        <Button
                                            type='button'
                                            color='primary'
                                            onClick={() => {
                                                setDateRangePopup(true)
                                            }}
                                            disabled={!sensorStatusUseFormik.values.vessel_id}
                                            sm={2}
                                        >
                                            Select date range
                                        </Button>
                                    </Col>
                                    <Col xs="auto" >
                                        <Label className="mb-0">Start date:
                                            <strong className="ms-2" key={refreshField}>
                                                {dateTimeFormat(sensorStatusUseFormik?.values?.startDate, false, false, true) ?? '-'}
                                            </strong>
                                        </Label>
                                    </Col>
                                    <Col xs="auto">
                                        <Label className="mb-0" id="endDate_lbl">End date:
                                            <strong style={{ marginLeft: '0.75rem' }} key={refreshField}>
                                                {dateTimeFormat(sensorStatusUseFormik?.values?.endDate, false, false, true) ?? '-'}
                                            </strong>
                                        </Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Card className='border-0 p-0'>
                                        <CardHeader className='pb-0'>
                                            <Nav tabs className="border-0">
                                                {/* Energy Parameter */}
                                                <NavItem>
                                                    <NavLink
                                                        style={{ cursor: "pointer" }}
                                                        className={classnames({
                                                            active: activeAdjustmentsTab === "1",
                                                        })}
                                                        onClick={() => {
                                                            toggle("1");
                                                        }}
                                                    >
                                                        Energy Meter
                                                    </NavLink>
                                                </NavItem>
                                                {/* Voyage Parameter */}
                                                <NavItem>
                                                    <NavLink
                                                        style={{ cursor: "pointer" }}
                                                        className={classnames({
                                                            active: activeAdjustmentsTab === "2",
                                                        })}
                                                        onClick={() => {
                                                            toggle("2");
                                                        }}
                                                    >
                                                        Revolution Counter
                                                    </NavLink>
                                                </NavItem>
                                                {/* Special Operation Energy */}
                                                <NavItem>
                                                    <NavLink
                                                        style={{ cursor: "pointer" }}
                                                        className={classnames({
                                                            active: activeAdjustmentsTab === "3",
                                                        })}
                                                        onClick={() => {
                                                            toggle("3");
                                                        }}
                                                    >
                                                        kWh meter
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                        </CardHeader>
                                        <CardBody className="p-2">
                                            {/* Energy Parameter */}
                                            <TabContent
                                                activeTab={activeAdjustmentsTab}
                                                className="text-muted p-0"
                                            >
                                                <TabPane tabId='1' className="mx-0">


                                                    {renderSensorTable(
                                                        energyMeterData,
                                                        loadingEnergy,
                                                        setEnergyMeterUrl,
                                                        energyMeterUrl,
                                                        "is_energy_meter_functional")}

                                                </TabPane>
                                            </TabContent>
                                            {/* Voyage Parameter */}
                                            <TabContent
                                                activeTab={activeAdjustmentsTab}
                                                className="text-muted p-0"
                                            >
                                                <TabPane tabId='2' className="mx-0">
                                                    {renderSensorTable(
                                                        revolutionCounterData,
                                                        loadingRevolution,
                                                        setRevolutionCounterUrl,
                                                        revolutionCounterUrl,
                                                        "is_revolution_counter_not_functional"
                                                    )}
                                                </TabPane>
                                            </TabContent>
                                            {/* Special Operation Energy */}
                                            <TabContent
                                                activeTab={activeAdjustmentsTab}
                                                className="text-muted p-0"
                                            >
                                                <TabPane tabId='3' className="mx-0">
                                                    {renderSensorTable(
                                                        kwhMeterData,
                                                        loadingKwh,
                                                        setKwhMeterUrl,
                                                        kwhMeterUrl,
                                                        "is_kwh_meter_not_functional"
                                                    )}
                                                </TabPane>
                                            </TabContent>

                                        </CardBody>
                                    </Card>
                                </Row>
                            </CardBody>
                        </Card>
                        <FormValuesDebug
                            values={[
                                sensorStatusUseFormik?.values,
                                sensorStatusUseFormik?.errors,
                                sensorStatusUseFormik?.touched,
                            ]}
                        />
                    </form>
                    <DateRangePopup
                        dateRangePopup={dateRangePopup}
                        setDateRangePopup={setDateRangePopup}
                        customReportUseFormik={sensorStatusUseFormik}
                        minDate={minDate}
                        maxDate={maxDate}
                        setFilterValues={setFilterValues}
                        setisPopupOpen={setisPopupOpen}
                        isPopupOpen={isPopupOpen}
                    />
                </Container>
            </div>
        </React.Fragment>
    )
}
